import { EntitiesActionFactory } from '../../../shared/utils/redux/entities/entities.actions'
import { ProviderDto } from '../../../shared/remote-services/dtos/provider.dto'

export class ProviderActions {
  public static providerActions = new EntitiesActionFactory<ProviderDto, void>(
    '[CORE] PROVIDER_ACTIONS',
  )
}
